import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import MasterViewController from "../../redux/actions/masterApiActions";
import DesignationFormModal from "./AddDesignation";
import ExportButton from "../../components/ag grid/ExportButton";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import "../../styles/styles.css";
import "../../styles/layout.css";

const DesignationList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [editDesignation, setEditDesignation] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const { getDesignations, deleteDesignation } = MasterViewController();
  const { designations } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(getDesignations());
  }, [dispatch]);

  const handleDelete = (id) => dispatch(deleteDesignation(id));

  const handleEdit = (designation) => {
    setEditDesignation(designation);
    setShowModal(true);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Designation Name",
      field: "name",
      flex: 1,
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex  mb-3" style={{ justifyContent: "space-between" }}>
        <div>
          {selectedRows.length > 0 && (
            <ExportButton
              gridRef={gridRef}
              fileName="designations.xlsx"
              exportColumns={["name"]}
            />
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <PageSizeSelector
          pageSize={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        />
        <div className="mt-2">
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => {
            setEditDesignation(null);
            setShowModal(true);
          }}
          sx={{
              borderRadius: "8px",
              backgroundColor: "#1976d2",
              textTransform: "none",
              paddingX: 2,
              height: "40px",             
              fontSize: "0.875rem",       
                       
            }}
        >
          Add Designation
        </Button>
        </div>
        </div>
      </div>

      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Designation List</h3>
          </Col>
        </Row>
      </div>

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={designations}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <DesignationFormModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editDesignation}
      />
    </div>
  );
};

export default DesignationList;
